import { useState, useEffect } from 'react'
import _ from 'lodash'

import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

import CustomTextField from '../common/wizard-custom-textfield'
import { AppContext } from '/providers/app-context'
import { uploadClientImage } from '/providers/templates-api'

function BusinessVCF({ wizardState, setWizardState, setPrevButtonState, setNextButtonState,templateId, template, setTemplate, objectData, setObjectData }) {

  const {apiSource, apiKeys} = useContext(AppContext)
  
  useEffect(() => {
    setPrevButtonState("enabled")
    setNextButtonState(wizardState.vcfCreated ? "enabled" : "disabled")
  }, [])

  const [sname,setSName] = useState("")
  const [fname,setFName] = useState("")
  const [title,setTitle] = useState("")

  const save = async () => {
    const contacts = template.backFields
    const vcf = createVCF({fname,sname,title,organisation:template.meta.title,contacts})

    const vcfUrl = await uploadClientImage({apiSource,apiKeys,templateId,filename:"contact.vcf",imageBuffer:vcf})
    //TODO handler error

    let t = _.cloneDeep(template)
    t.barcode.message = vcfUrl
    t.barcode.altText = "Scan me!"
    setTemplate(t)

    let o = _.cloneDeep(objectData)
    o.barcode.value = vcfUrl
    o.barcode.alternateText = "Scan me!"
    setObjectData(o)

    setNextButtonState("enabled")

    let ws = _.cloneDeep(wizardState)
    ws.vcfCreated = true
    setWizardState(ws)
  }
  
  const setFNameValue = value => {
    setFName(value)
    resetVCFCreated()
  } 

  const setSNameValue = value => {
    setSName(value)
    resetVCFCreated()
  } 

  const setTitleValue = value => {
    setTitle(value)
    resetVCFCreated()
  } 

  const resetVCFCreated = () => {
    setNextButtonState("disabled")

    let ws = _.cloneDeep(wizardState)
    ws.vcfCreated = false
    setWizardState(ws)
  }


  return (
    <div className="mb-10">
      <Typography variant='h3' sx={{p:2}}>VCF File</Typography>
      <p className="mb-5">A VCF file contains your contact details in a format that can be imported into
      a contacts applications.</p>
      
      <p className="mb-5">We will automatically create that for you here. 
      Your barcode will link to this file.</p>
      
      <p className="mb-5">Show your barcode to someone to enable them to dowload and install your contact details.</p>

      <p className="mb-5">You may add your title and name here if you wish</p>
      
      <CustomTextField label="First Name" valid={true} value={fname} onChange={setFNameValue} />
      <CustomTextField label="Last Name" valid={true} value={sname} onChange={setSNameValue} />
      <CustomTextField label="Job Title" valid={true} value={title} onChange={setTitleValue} />

      <Button variant="outlined" onClick={save}>Save VCF file</Button>
    </div>
  )
}

export default BusinessVCF

const getNote = (index,label,value) => `NOTE:${label}\\n${value.replace(/\n/g,'\\n')}\n`
const getEmail = (index,label,value) => `EMAIL;TYPE=${label},INTERNET:${value}\n`
const getPhone = (index,label,value) => `TEL;TYPE=${label},VOICE:${value}\n` 
const getUrl = (index,label,value) => `item${index}.URL:${value}\nitem${index}.X-ABLabel:${label}\n`


const contactTypes = {
  text : getNote,
  www : getUrl,
  phone : getPhone,
  email : getEmail,
}


const createVCF = ({fname,sname,title,organisation,contacts}) => {
  let vcf = `BEGIN:VCARD\n` +
    `VERSION:3.0\n`

    if (sname.length ||fname.length) vcf += `N:${sname};${fname};;;\n`
    if (organisation.length) vcf += `ORG:${organisation}\n`
    if (title.length) vcf += `TITLE:${title}\n`

    contacts.forEach((c,i) => {
      vcf += contactTypes[c.type](i+1,c.label,c.value)
    })

    vcf += `END:VCARD\n`
  
    return vcf
}

